import { render } from "./QuotationView.vue?vue&type=template&id=ae436bee"
import script from "./QuotationView.vue?vue&type=script&lang=js"
export * from "./QuotationView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__